import { render, staticRenderFns } from "./FavorabilityToggle.vue?vue&type=template&id=2a5d6b58&scoped=true"
import script from "./FavorabilityToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./FavorabilityToggle.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FavorabilityToggle.vue?vue&type=style&index=0&id=2a5d6b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5d6b58",
  null
  
)

export default component.exports